import React, { useMemo, useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

import { FormProvider, useFieldArray, useForm, useWatch } from 'react-hook-form'

import { Checkbox, Input } from '@/components/Form'
import GCMATERIAL_FIELD_SCHEMA from '../constants/GCMaterialFieldSchema'
import { Box, Button, Flex, Heading } from '@chakra-ui/react'

import useGCMaterial from '@/features/GCMaterials/useGCMaterials'
import { validateFormRequiredFields } from '@/utils/form.helper'
import { toast } from 'react-toastify'
import EditableTable from '@/components/Table/EditableTable'
import { createColumnHelper } from '@tanstack/react-table'
import { InputCell } from '@/components/Table/components/Cell'
import { DeleteButton } from '@/components/Elements/Button'
import { getGCMaterialDetailTableColumns } from '@/features/GCMaterials/constants/GCMaterialTableColumns'
import { renderFormField } from '@/utils/renderForm'

const GCMaterialDetailPage = () => {
  const { id } = useParams()

  const methods = useForm({
    defaultValues: {
      SEN: '',
      articleType: '',
      unitCost: 0,
      currency: '',
      unit: '',
      MOQ: 0,
      ECCN: '',
      ctyOfOrigin: '',
      description: '',
      SAPMaterialNumber: '',
      purchaseScenario: '',
      CSID: false,
      zuroa: false,
      priceTerm: '',
      chargeType: '',
    },
  })
  const navigate = useNavigate()
  const { useUpdateGCMaterial, useFetchGCMaterial } = useGCMaterial()
  const updateGCMaterial = useUpdateGCMaterial()
  const { data: GCMaterialResponse } = useFetchGCMaterial(id)
  useEffect(() => {
    if (GCMaterialResponse) {
      methods.reset(GCMaterialResponse?.data)
    }
  }, [GCMaterialResponse, methods])
  const onSubmit = async ({ id, ...data }) => {
    try {
      const requiredFields = {
        SEN: 'SEN',
        articleType: 'Article Type',
        unitCost: 'Unit Cost',
        currency: 'Currency',
        unit: 'Unit',
        MOQ: 'MOQ',
      }

      validateFormRequiredFields(data, requiredFields)

      const res = await updateGCMaterial.mutateAsync({
        id,
        data: data,
      })
      navigate(`/admin/GCMaterials/`)
    } catch (err) {
      toast.error(err?.message ?? '')
    }
  }

  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
          <Flex p={5} borderBottom="1px solid #d8dbe0">
            <Heading> GC Material Detail </Heading>
          </Flex>
          <Box p="5">
            <Flex direction={'column'} gap="3">
              {GCMATERIAL_FIELD_SCHEMA.map(renderFormField)}
            </Flex>

            <Button mt="6" colorScheme="blue" type="submit">
              Save
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  )
}

export default GCMaterialDetailPage
